/** @format */

import { setBopisInventory, setEcommInventory } from '@pdp/data-access/state';

import { ISkuLocation } from '@shared/data-access/interfaces';
import { Injectable } from '@angular/core';
import { Store as NGRXStore } from '@ngrx/store';
import { StoreService } from '@shared/data-access/services';

@Injectable({
	providedIn: 'root'
})
export class ProductSelectionInventoryService {
	constructor(
		private storeService: StoreService,
		private ngrxStore: NGRXStore
	) {}

	setInventoryResultsToState(
		isProductAvailable: boolean,
		bopisLocation: number | string,
		skuIdList: string[]
	) {
		let shipToMeInventoryMap: ISkuLocation[];
		let bopisLocationInventoryMap: ISkuLocation[];

		if (isProductAvailable) {
			const shipToMeLocation = 0;

			// Store list to get inventory for
			const storeList = [];

			// Add location "0" to the list (STH)
			storeList.push(shipToMeLocation);

			// Check to see if the BOPIS location is defined
			if (typeof bopisLocation === 'number') {
				storeList.push(bopisLocation);
			}

			this.storeService
				.getSkuInventoryByLocation$(skuIdList, storeList, 1)
				.subscribe({
					next: (res: ISkuLocation[]) => {
						// Store Number of '0' is passed to method in order to get available to ship products from eComm inventory
						shipToMeInventoryMap = this.storeService.filterResults(
							res,
							shipToMeLocation
						);

						// Attempt to get the filtered results for BOPIS...if BOPIS location is undefined then an empty Array will be set
						bopisLocationInventoryMap = this.storeService.filterResults(
							res,
							bopisLocation
						);
					},
					error: () => {
						// Set to an empty Array
						shipToMeInventoryMap = [];

						// Set to an empty Array
						bopisLocationInventoryMap = [];
					}
				})
				.add(() => {
					// State Ecomm Inventory in State
					this.ngrxStore.dispatch(
						setEcommInventory({ ecommInventory: shipToMeInventoryMap })
					);
					// State Bopis Inventory in State
					this.ngrxStore.dispatch(
						setBopisInventory({
							bopisInventory: bopisLocationInventoryMap
						})
					);
				});
		} else {
			// Set to an empty Array
			shipToMeInventoryMap = [];

			// State Ecomm Inventory in State
			this.ngrxStore.dispatch(setEcommInventory({ ecommInventory: shipToMeInventoryMap }));
		}
	}
}
